// OK 04/11/2024

import { useEffect, useState } from "react";
import { getFuelCardAlert } from "../../apis/fuelCard";
import { getVehAssAlert, getVehCTAlert } from "../../apis/vehicule";
import AlertContext from "../../context/AlertContext";
import { Vehicule } from "../../interfaces";
import { FuelCard } from "../../interfaces/FuelCard.interface";

export default function AlertProvider(props: { children: any }) {
  const [alertCarteCarbu, setAlertCarteCarbu] = useState<boolean>(false);
  const [numberAlertCarteCarbu, setNumberAlertCarteCarbu] = useState<
    FuelCard[]
  >([]);
  const [alertVehCT, setAlertVehCT] = useState<boolean>(false);
  const [numberAlertVehCT, setNumberAlertVehCT] = useState<Vehicule[]>([]);
  const [alertVehAss, setAlertVehAss] = useState<boolean>(false);
  const [numberAlertVehAss, setNumberAlertVehAss] = useState<Vehicule[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const carteCarbu = await getFuelCardAlert();
        if (carteCarbu.length > 0) {
          setAlertCarteCarbu(true);
          setNumberAlertCarteCarbu(carteCarbu);
        }
        const vehCT = await getVehCTAlert();
        if (vehCT.length > 0) {
          setAlertVehCT(true);
          setNumberAlertVehCT(vehCT);
        }
        const vehAss = await getVehAssAlert();
        if (vehAss.length > 0) {
          setAlertVehAss(true);
          setNumberAlertVehAss(vehAss);
        }
      } catch {}
    };
    fetchData();
  }, []);

  console.log(numberAlertVehAss);

  return (
    <AlertContext.Provider
      value={{
        alertCarteCarbu,
        setAlertCarteCarbu,
        numberAlertCarteCarbu,
        setNumberAlertCarteCarbu,
        alertVehCT,
        setAlertVehCT,
        numberAlertVehCT,
        setNumberAlertVehCT,
        alertVehAss,
        setAlertVehAss,
        numberAlertVehAss,
        setNumberAlertVehAss,
      }}
    >
      {props.children}
    </AlertContext.Provider>
  );
}
